__turbopack_context__.v({
  "noChildren": "FolderTreeBranch-module__q316ua__noChildren",
  "rootTreeList": "FolderTreeBranch-module__q316ua__rootTreeList",
  "treeItem": "FolderTreeBranch-module__q316ua__treeItem",
  "treeList": "FolderTreeBranch-module__q316ua__treeList",
});
